import { CellContext } from '@tanstack/react-table';
import { TourPriceDto } from '@/features/dashboard/tourConfig/types/TourPriceDto.ts';
import { formatNumber, splitAmountWithCurrency } from '@/utils/formatters.ts';
import { getCurrencySymbol } from '@/features/dashboard/paymentConfig/types/Currency.utils.ts';
import { CellSecondary } from '@/components/table/_fieldDefinitions/_base/CellSecondary.tsx';
import { EmptyValue } from '@/components/ui/EmptyValue.tsx';

/**
 * Cennik wyjazdu jako `200–300 zł`. Waluta pada raz, na końcu: backend nie
 * obsługuje jeszcze kilku walut w jednym wyjeździe, więc bierzemy pierwszą.
 */
export const tourPriceArrayFieldRender = <T,>(
  info: CellContext<T, unknown>,
) => {
  const value = info.getValue();
  if (!Array.isArray(value) || value.length === 0) {
    return <EmptyValue />;
  }

  const prices = value as TourPriceDto[];
  const amounts = prices.map((tourPrice) => tourPrice.price.amount);
  const min = Math.min(...amounts);
  const max = Math.max(...amounts);

  const { main, secondary } =
    min === max
      ? splitAmountWithCurrency(min, prices[0].price.currency)
      : {
          main: `${formatNumber(min)}–${formatNumber(max)}`,
          secondary: ` ${getCurrencySymbol(prices[0].price.currency)}`,
        };

  return (
    <>
      {main}
      <CellSecondary>{secondary}</CellSecondary>
    </>
  );
};
